
import React, { useState, useEffect } from 'react';
import { AppProvider, useApp } from './AppContext';
import Navbar from './components/Navbar';
import CartDrawer from './components/CartDrawer';
import StoreFront from './pages/StoreFront';
import AdminPage from './pages/AdminPage';
import CheckoutPage from './pages/CheckoutPage';

const Router: React.FC = () => {
  const [route, setRoute] = useState(window.location.hash || '#/admin');
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { setCurrentStoreBySlug, stores } = useApp();

  // Força redirecionamento para admin se abrir na raiz pela primeira vez
  useEffect(() => {
    if (!window.location.hash || window.location.hash === '#/') {
      window.location.hash = '#/admin';
    }
  }, []);

  useEffect(() => {
    const handleHashChange = () => setRoute(window.location.hash || '#/admin');
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Sincroniza a loja atual baseada no slug da URL
  useEffect(() => {
    const cleanRoute = route.startsWith('#') ? route.substring(1) : route;
    
    const isSystemRoute = cleanRoute === '/admin' || cleanRoute === '/checkout';
    const isRootRoute = cleanRoute === '/' || cleanRoute === '' || cleanRoute === '#/';

    // Só tentamos carregar loja se NÃO for uma rota de sistema
    if (!isSystemRoute && !isRootRoute) {
      const slug = cleanRoute.startsWith('/') ? cleanRoute.substring(1) : cleanRoute;
      if (slug) {
        setCurrentStoreBySlug(slug);
      }
    }
  }, [route, setCurrentStoreBySlug]);

  const renderPage = () => {
    const cleanRoute = route.startsWith('#') ? route.substring(1) : route;
    
    if (cleanRoute === '/admin' || cleanRoute === '/' || cleanRoute === '') return <AdminPage />;
    if (cleanRoute === '/checkout') return <CheckoutPage />;
    
    // Default: Página de Loja (StoreFront)
    return <StoreFront />;
  };

  // Esconde Navbar na rota de admin (Login) e checkout para foco total
  const cleanRoute = route.startsWith('#') ? route.substring(1) : route;
  const showNavbar = cleanRoute !== '/admin' && cleanRoute !== '/checkout' && cleanRoute !== '/' && cleanRoute !== '';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {showNavbar && <Navbar onOpenCart={() => setIsCartOpen(true)} />}
      <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      
      <main className="flex-1 transition-all duration-300">
        {renderPage()}
      </main>
      
      <footer className="py-8 text-center text-gray-400 text-[10px] font-bold uppercase tracking-widest">
        LocalCommerce &copy; 2024 - Sistema de Pedidos Inteligente
      </footer>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AppProvider>
      <Router />
    </AppProvider>
  );
};

export default App;
